<template>
    <div>
        <modal :title="$t(title)" :visible.sync="isShowDialog" width="700px">
            <el-form ref="form" :rules="rules" :model="dioForm" label-width="180px">
                <el-form-item prop="name" :label="$t('integration.customer_name')">
                    <el-input type="text" v-model.trim="dioForm.name" :placeholder="$t('integration.please_enter_the_customer_name')" style="width:250px"></el-input>
                </el-form-item>
                <el-form-item prop="code" :label="$t('integration.customer_code')">
                    <el-input type="text" v-model.trim="dioForm.code" :placeholder="$t('integration.please_enter_the_code')" style="width:250px"></el-input>
                </el-form-item>
                <el-form-item prop="status" :label="$t('integration.customer_status')">
                    <el-select v-model="dioForm.status" style="width:250px">
                        <el-option v-for="item in statusArray" :key="item.value" :value="item.value" :label="$t(item.label)"> </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="area" :label="$t('integration.region')">
                    <el-input type="text" v-model.trim="dioForm.area" :placeholder="$t('integration.please_enter_the_area')" style="width:250px"></el-input>
                </el-form-item>

                <el-form-item prop="areaCode" :label="$t('integration.code')">
                    <el-input type="text" v-model.trim="dioForm.areaCode" :placeholder="$t('integration.please_enter_the_code')" style="width:250px"></el-input>
                </el-form-item>

                <el-form-item prop="address" :label="$t('integration.customer_address')">
                    <div class="uk-flex uk-flex-middle">
                        <el-input type="text" v-model.trim="dioForm.address" :placeholder="$t('integration.please_enter_the_customer_address')" style="width:250px"></el-input>
                        <div class="uk-margin-small-left">
                            <el-button @click="toLocate" icon="el-icon-location-outline"></el-button>
                        </div>
                    </div>
                </el-form-item>

                <el-form-item prop="contact" :label="$t('integration.contacts')">
                    <el-input type="text" v-model.trim="dioForm.contact" :placeholder="$t('integration.please_enter_the_contact_person')" style="width:250px"></el-input>
                </el-form-item>
                <el-form-item prop="phone" :label="$t('integration.contact_information')">
                    <el-input type="text" v-model.trim="dioForm.phone" :placeholder="$t('integration.please_enter_the_contact_information')" style="width:250px"></el-input>
                </el-form-item>
                <el-form-item prop="email" :label="$t('integration.e-mail')">
                    <el-input type="text" v-model.trim="dioForm.email" :placeholder="$t('integration.please_enter_email_address')" style="width:250px"></el-input>
                </el-form-item>

                <el-form-item :label="$t('integration.monitoring_point_type')" prop="monitorType" required>
                    <el-select v-model="dioForm.monitorType" multiple>
                        <el-option :label="getLanguage() === 'zh_CN'?item.name: item.code" :value="key" v-for="(item, key) in $store.state.carrierType" :key="key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('integration.inform_the_customer')">
                    <el-checkbox v-model="email" :true-label="1" :false-label="0">{{ $t('integration.email_notification') }}</el-checkbox>
                    <el-checkbox v-model="mobile" :true-label="1" :false-label="0">{{ $t('integration.sms_notification') }}</el-checkbox>
                </el-form-item>

                <el-form-item :label="$t('public.table_desc')" prop="description">
                    <el-input v-model.trim="dioForm.description" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" style="width:250px" maxlength="250" show-word-limit></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer">
                <el-button type="primary" @click="isShowDialog = false">{{ $t('buttonTitle.Close') }}</el-button>
                <el-button type="primary" @click="handleSave">{{ $t('public.btn_ok') }}</el-button>
            </div>
        </modal>
        <Locate :showLocate.sync="showLocate" v-if="showLocate" :dioForm.sync="dioForm"></Locate>
    </div>
</template>
<script>
import { customerNew } from '@/api/modules/range.js';
import Locate from './Locate.vue';
import { getLanguage } from '@/lang';

export default {
    props: ['title', 'isShow', 'statusArray', 'typeArray'],
    components: {
        Locate
    },
    computed: {
        isShowDialog: {
            get: function() {
                return this.isShow;
            },
            set: function(val) {
                this.$emit('update:isShow', val); //可以优化成model  或者minx
            }
        },
        rules() {
            return {
                name: [
                    { required: true, message: $t('integration.customer_name_cannot_be_empty'), trigger: 'blur' },
                    {
                        max: 50,
                        message: $t('integration.length_within_50'),
                        trigger: 'blur'
                    }
                ],
                shortName: [
                    {
                        max: 30,
                        message: $t('public.len_max_30'),
                        trigger: 'blur',
                        required: false
                    }
                ],
                code: [
                    { required: true, message: $t('integration.customer_code_cannot_be_empty'), trigger: 'blur' },
                    {
                        max: 20,
                        message: $t('integration.length_within_20'),
                        trigger: 'blur'
                    },
                    {
                        validator: this.$fromRules.FormValidate.Form().Code,
                        trigger: 'blur'
                    }
                ],
                status: [{ required: true, message: $t('integration.customer_status_cannot_be_empty'), trigger: 'change' }],
                area: [
                    {
                        required: false,
                        max: 120,
                        message: $t('integration.length_within_120'),
                        trigger: 'blur'
                    }
                ],
                areaCode: [
                    {
                        required: false,
                        max: 20,
                        message: $t('integration.length_within_20'),
                        trigger: 'blur'
                    },
                    {
                        validator: this.$fromRules.FormValidate.Form().Codes,
                        trigger: 'blur'
                    }
                ],
                address: [
                    {
                        max: 255,
                        message: $t('integration.length_within_255'),
                        trigger: 'blur',
                        required: false
                    }
                ],
                contact: [
                    { required: true, message: $t('integration.contact_cannot_be_empty'), trigger: 'blur' },
                    {
                        max: 30,
                        message: $t('public.len_max_30'),
                        trigger: 'blur',
                        required: false
                    }
                ],
                phone: [
                    { required: true, message: $t('integration.contact_information_cannot_be_empty'), trigger: 'blur' },
                    {
                        max: 30,
                        message: $t('public.len_max_30'),
                        trigger: 'blur'
                    }
                ],
                email: [
                    { required: true, message: $t('integration.mailbox_cannot_be_empty'), trigger: 'blur' },
                    {
                        max: 255,
                        trigger: 'blur',
                        message: $t('integration.length_within_255')
                    },
                    {
                        validator: this.$fromRules.FormValidate.Form().Email,
                        trigger: 'blur'
                    }
                    // {
                    //   type: 'email',
                    //   message: $t('integration.please_enter_the_correct_email_address'),
                    //   trigger: ['blur', 'change']
                    // }
                ],
                monitorType: [{ required: true, message: $t($t('integration.select_at_least_one_monitoring_point_type')), trigger: 'change' }]
            };
        }
    },
    data() {
        return {
            email: 0,
            mobile: 0,
            dioForm: {
                name: '',
                code: '',
                area: '',
                areaCode: '',
                shortName: '',
                status: '1',
                contact: '',
                phone: '',
                orgtype: '00',
                email: '',
                description: '',
                address: '',
                lng: null,
                lat: null,
                monitorType: []
            },
            // 是否显示定位对话框
            showLocate: false,
            getLanguage
        };
    },
    methods: {
        // 跳转到客户定位页面
        toLocate() {
            this.showLocate = true;
        },
        clearValidate() {
            this.email = 0;
            this.mobile = 0;
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },
        async justify() {
            try {
                return await this.$refs['form'].validate();
            } catch (error) {
                return false;
            }
        },
        async handleSave() {
            let falg = await this.justify();
            if (!falg) return;

            const monitorType = this.dioForm.monitorType.join(',');
            delete this.dioForm.monitorType;

            customerNew(this.dioForm, this.email, this.mobile, monitorType).then(({ result, state }) => {
                if (result === 200) {
                    this.$message.success(this.$t('public.tip_add_succ'));
                    this.isShowDialog = false;
                    // this.$parent.getAgainFn()
                    this.$parent.getListFn();
                } else if (result === 201) {
                    this.$message.error($t('integration.customer_creation_succeeded_c__but_default_role_creation_failed'));
                } else if (result === 202) {
                    this.$message.error($t('integration.create_customer_c__default_role_succeeded_c__but_create_user_failed'));
                } else if (result === 203) {
                    this.$message.error($t('integration.create_customer_c__default_role_c__user_succeeded_c__but_contact_synchronization_failed'));
                } else if (result === 406) {
                    this.$message.error($t('integration.customer_code_can_only_be_filled_in_uppercase_and_lowercase_english_letters_c__and_numbers_cannot_be_greater_than_20_in_length'));
                } else if (result === 408) {
                    this.$message.error($t('integration.customer_name_cannot_be_greater_than_50_in_length'));
                } else if (result === 409) {
                    this.$message.error($t('integration.the_customer_abbreviation_cannot_be_greater_than_30'));
                } else if (result === 410) {
                    this.$message.error($t('integration.customer_type_cannot_be_empty'));
                } else if (result === 411) {
                    this.$message.error($t('integration.the_area_cannot_be_longer_than_120'));
                } else if (result === 412) {
                    this.$message.error($t('integration.the_area_code_can_only_be_filled_in_uppercase_and_lowercase_english_letters_c__numbers_c__and_underscores_c__and_cannot_be_greater_than_20_in_length'));
                } else if (result === 413) {
                    this.$message.error($t('integration.customer_status_cannot_be_empty'));
                } else if (result === 414) {
                    this.$message.error($t('integration.the_customer_address_cannot_be_greater_than_255_in_length'));
                } else if (result === 415) {
                    this.$message.error($t('integration.customer_contact_cannot_be_longer_than_30'));
                } else if (result === 416) {
                    this.$message.error($t('integration.contact_information_can_only_be_filled_with_numbers_and_middle_bars_c__and_cannot_be_greater_than_20_in_length'));
                } else if (result === 417) {
                    this.$message.error($t('integration.description_cannot_be_longer_than_250'));
                } else if (result === 418) {
                    this.$message.error($t('integration.the_same_customer_name_already_exists'));
                } else if (result === 419) {
                    this.$message.error($t('integration.email_address_is_required_and_must_conform_to_the_email_format'));
                } else if (result === 420) {
                    this.$message.error($t('integration.the_same_customer_code_already_exists'));
                } else if (result === 421) {
                    this.$message.error($t('integration.the_same_email_already_exists'));
                } else if (result === 422) {
                    this.$message.error($t('integration.the_same_mobile_number_already_exists'));
                } else {
                    this.$message.error($t('integration.system_error'));
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-textarea__inner {
    border-radius: 2px;
    margin-left: 5px;
}
</style>
